export default "__VITE_ASSET__CCNKkUi___"